<div class="main-body leftmenu">
    <router-outlet></router-outlet>

</div>